const toggles = document.querySelectorAll("[data-toggle-offscreen]");

toggles.forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
        e.preventDefault();

        const id = toggle.dataset.toggleOffscreen;
        const offscreen = document.getElementById(id);
        console.log(offscreen);
        const relatedToggles = document.querySelectorAll(
            `[data-toggle-offscreen="${id}"]`,
        );

        offscreen?.classList.toggle("is-open");
        relatedToggles.forEach((relatedToggle) => {
            relatedToggle.classList.toggle("is-open");
        });
    });
});
